import { useMemo } from 'react';
import { TNotification } from '../../constant/types';
import { Card, List } from 'antd';
import { getTimeFromUnixTimestamp, reqReadNotification, unixToDateString } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../redux/reducers';
import { MANAGE_COMMON } from '../../redux/actions/actionTypes';
import clsx from 'clsx';
import { ReadNotification, UnreadNotification } from '../../assets';
import { useHistory } from 'react-router-dom';

const Notification = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {listNotification } = useSelector((app: AppState) => app.common);

    const readNotification = async (notification_id: number, redirect_path: string) => {
        const response = await reqReadNotification({
            notification_id: notification_id
        })

        if (response) {
            dispatch(MANAGE_COMMON.COUNT_NOTIFICATION());
        }
        history.push(redirect_path);
    }

    const listNotificationView = useMemo(() => {
        return (
            <List
            className="overflow-x-hidden overflow-y-auto text-justify h-[100%] pb-24"
            dataSource={listNotification}
                renderItem={(item: TNotification) => (
                    <List.Item
                        style={{ cursor: 'pointer', width: '100%' }}
                        onClick={() => readNotification(item.id, item.redirect_path)}
                    >
                     <Card className='shadow-card w-[50%] max-w-[580px]' >
                            <div
                                className='flex flex-row items-center w-full justify-around'
                            >
                                <img src={item.status === 0 ? UnreadNotification : ReadNotification} alt="notification" className='w-8 h-8 mr-4'></img>
                                <div
                                    className={clsx('flex flex-col opacity-70 ', 
                                     {'!opacity-100':  item.status === 0,}
                                    )
                                }
                                >
                                    <span className='text-[16px] font-semibold'>

                                        {item.message}
                                    </span>
                                    <div
                                        className={clsx('flex flex-row items-center gap-2', {
                                            'font-semibold': item.status === 0,
                                            'font-normal': item.status !== 0,
                                            'text-grey': item.status !== 0,
                                            "text-base": item.status === 0,
                                        
                                        })}
                                    >
                                        <p>{unixToDateString(item.created_at)} - </p>
                                        <p>{getTimeFromUnixTimestamp(item.created_at)} - </p>
                                        <p>{item.status === 0 ? "Chưa đọc" : "Đã đọc"}</p>
                                    </div>
                                </div>
                                <div
                                    className={clsx(' rounded-full !w-[12px] !h-[12px] ml-2 bg-base invisible ', {
                                        '!visible': item.status === 0,
                                    })}
                                />
                            </div>
                        </Card>
                    </List.Item>
                )}
            >
            </List>
        );
    }, [listNotification]);
    return (
        // JSX markup goes here
        <div className=" h-screen flex flex-col items-center p-8">
            <div className='container_sub_content'>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: "100%" }}>
                    <p className="text-4xl font-bold">Thông báo</p>
                </div>
                {listNotificationView}
            </div>
        </div>

    );
};

export default Notification;